import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import parseSRT from 'parse-srt';

import {
  Panel,
  DataList,
  FileButton,
  LinkButton,
  ButtonGroup,
} from 'rc-easyui';

//var XMLParser = require('react-xml-parser');

var fs = require('fs');

class SelectFiles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
    };
  }

  async handleSelect(files) {
    files.forEach((file) => {
      file.url = window.URL.createObjectURL(file);

      fs.readFile(file.url, function (err, buf) {
        // console.log(buf.toString());

        let jsonSubs = parseSRT(buf);

        // console.log(`jsonSubs ${JSON.stringify(jsonSubs)}`);
      });
    });
    await this.setState({
      files: this.state.files.concat(files),
    });

    // alert(`files ${JSON.stringify(this.state.files)}`);

    //[{"url":"blob:http://localhost:3000/ead0ec0a-92c1-480f-a9f8-1b59843f759f"}]

    // var xml = new XMLParser().parseFromString(xmlText);    // Assume xmlText contains the example XML
    // console.log(xml);
    // console.log(xml.getElementsByTagName('Name'));
  }
  handleRemoveFile(file) {
    const files = this.state.files.filter((f) => f !== file);
    this.setState({
      files: files,
    });
  }
  handleClear() {
    this.setState({ files: [] });
  }
  renderItem({ row }) {
    return (
      <div className='fileitem'>
        <img alt='' src={row.url} />
        <div className='name'>{row.name}</div>
        <div className='size'>{row.size}</div>
        <LinkButton
          iconCls='icon-clear'
          plain
          onClick={() => this.handleRemoveFile(row)}
        ></LinkButton>
      </div>
    );
  }

  async componentDidMount() {
    await this.setState({ value: this.props.project.statusValue });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  render() {
    let mainContent;

    mainContent = (
      <div>
        <h2>Select Files</h2>
        <Panel style={{ width: 600 }}>
          <div className='panel-header' style={{ border: 0 }}>
            <ButtonGroup>
              <FileButton
                style={{ width: 110 }}
                text='Select Files...'
                accept='text/xml'
                multiple
                onSelect={this.handleSelect.bind(this)}
              />
              <LinkButton
                style={{ width: 80 }}
                onClick={this.handleClear.bind(this)}
              >
                Clear
              </LinkButton>
            </ButtonGroup>
          </div>
          <DataList
            style={{ minHeight: 100 }}
            border={false}
            data={this.state.files}
            renderItem={this.renderItem.bind(this)}
          />
        </Panel>
      </div>
    );

    return mainContent;
  }
}

SelectFiles.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
});

export default connect(mapStateToProps, {})(withRouter(SelectFiles));



// WEBPACK FOOTER //
// ./src/components/translations/objects/SelectFiles.js